import API from '../api/index';
import IActividad from '../types/Actividad';
import IEmpleado from '../types/Empleado';
import IHoliday from '../types/Holiday';
import IAsistenciaDoc from '../types/AsistenciaDoc';
import IMail, { IFalloMail } from '../types/Mail';
import IOutOffice from '../types/OutOffice';
import ISala from '../types/Sala';
import IConsentimientoDoc from '../types/CI';
import IServicio from '../types/Servicio';
import IMetodoPago from '../types/MetodoPago';
import { IAgendaConfig } from '../types/AgendaConfig';
import IEntidadFacturacion, { CasoCambioTitular, ICambioTitularOpciones, IEntidadFacturacionCreatePayload, IEntidadFacturacionDatos } from '../types/EntidadFacturacion';

const getConfig = (id: string) => API.get(`/config${id}`);

const createEmpleado = (data: IEmpleado) => API.post('/empleado', data);
const updateEmpleado = (_id: string, data: IEmpleado) => API.patch(`/empleado${_id}`, data);
const deleteEmpleado = (_id: string) => API.delete(`/empleado${_id}`);

const createOutOffice = (data: IOutOffice) => API.post('/outoffice', data);
const updateOutOffice = (_id: string, data: IOutOffice) => API.patch(`/outoffice${_id}`, data);
const deleteOutOffice = (_id: string) => API.delete(`/outoffice${_id}`);

const createActividad = (data: IActividad) => API.post('/actividad', data);
const updateActividad = (_id: string, data: IActividad) => API.patch(`/actividad${_id}`, data);
const deleteActividad = (_id: string) => API.delete(`/actividad${_id}`);

const createSala = (data: ISala) => API.post('/sala', data);
const updateSala = (_id: string, data: ISala) => API.patch(`/sala${_id}`, data);
const deleteSala = (_id: string) => API.delete(`/sala${_id}`);

const updateFestivos =  (_id: string, data: IHoliday[]) => API.patch(`/holidays${_id}`, data);

const createMail = (data: IMail) => API.post('/mail', data);
const updateMail = (_id: string, data: IMail) => API.patch(`/mail${_id}`, data);
const deleteCorreo = (_id: string) => API.delete(`/mail${_id}`);
const getMailEstado = () => API.get<{ fallo: IFalloMail | null }>('/mail-estado');

const createAsistenciaDoc = (data: IAsistenciaDoc) => API.post('/asistenciadoc', data);
const updateAsistenciaDoc = (_id: string, data: IAsistenciaDoc) => API.patch(`/asistenciadoc${_id}`, data);
const deleteAsistenciaDoc = (_id: string) => API.delete(`/asistenciadoc${_id}`);

const saveCI = (data: IConsentimientoDoc) => API.post('/consentimientodoc', data);
const updateCI = (_id: string, data: IConsentimientoDoc) => API.patch(`/consentimientodoc${_id}`, data);

const createServicio = (data: IServicio) => API.post('/servicio', data);
const updateServicio = (_id: string, data: IServicio) => API.put(`/servicio/${_id}`, data);
const updateServicioActivo = (_id: string, payload: { activo: boolean; userId: string }) => API.patch(`/servicio/${_id}/activo`, payload);

const createMetodoPago = (data: IMetodoPago) => API.post('/metodopago', data);
const updateMetodoPagoActivo = (_id: string, payload: { activo: boolean; userId: string }) => API.patch(`/metodopago/${_id}/activo`, payload);

const updateReminder = (userId: string, data: { enabled: boolean }) => API.put(`/reminder/${userId}`, data);
const updateOverlap = (userId: string, data: { enabled: boolean }) => API.put(`/overlap/${userId}`, data);
const updateAgendaConfig = (userId: string, data: IAgendaConfig) => API.put(`/agendaConfig/${userId}`, data);

const updateWaConfig = (userId: string, data: { enabled: boolean }) => API.put(`/waConfig/${userId}`, data);

const updateUserCurrency = (userId: string, currency: string) => API.patch(`/userCurrency/${userId}`, { currency });

const createEntidadFacturacion = (data: IEntidadFacturacionCreatePayload) => API.post<IEntidadFacturacion>('/entidad-facturacion', data);
const updateEntidadFacturacion = (userId: string, entidadId: string, data: IEntidadFacturacionDatos & ICambioTitularOpciones) => API.patch<{ caso: CasoCambioTitular, datosFacturacionAdicional: IEntidadFacturacion[] }>(`/entidad-facturacion/${userId}/${entidadId}`, data);
const deactivateEntidadFacturacion = (userId: string, entidadId: string) => API.patch(`/entidad-facturacion/${userId}/${entidadId}/desactivar`);
const activateEntidadFacturacion = (userId: string, entidadId: string) => API.patch(`/entidad-facturacion/${userId}/${entidadId}/activar`);

const ConfigService = {
    getConfig,
    createEmpleado,
    updateEmpleado,
    deleteEmpleado,
    createOutOffice,
    updateOutOffice,
    deleteOutOffice,
    createActividad,
    updateActividad,
    deleteActividad,
    createSala,
    updateSala,
    deleteSala,
    updateFestivos,
    createMail,
    updateMail,
    deleteCorreo,
    getMailEstado,
    createAsistenciaDoc,
    updateAsistenciaDoc,
    deleteAsistenciaDoc,
    saveCI,
    updateCI,
    createServicio,
    updateServicio,
    updateServicioActivo,
    createMetodoPago,
    updateMetodoPagoActivo,
    updateReminder,
    updateOverlap,
    updateAgendaConfig,
    updateWaConfig,
    updateUserCurrency,
    createEntidadFacturacion,
    updateEntidadFacturacion,
    deactivateEntidadFacturacion,
    activateEntidadFacturacion
};

export default ConfigService;